import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User, PlusiPoints } from '../../../_models';
import { UserService, UtilsService } from 'src/app/_services';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.css']
})
export class UserCardComponent implements OnInit {

  public user : User;
  public userCardForm: FormGroup; 
  public submitted : boolean;

  public useCard : boolean;
  public requestCard : boolean;
  public validated : boolean;
  public validCard :boolean;

  public date : Date;
  public plusiPoints : PlusiPoints;

  get f() { 
    return this.userCardForm.controls; 
  }


  constructor(
    private formBuilder: FormBuilder,
    private users : UserService,
    private translate: TranslateService,
    private utils: UtilsService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
  ) { 
    this.users.editingUser.subscribe(user => {
          this.user = user;
          this.refreshPoints();
    });

    this.submitted = false;
    this.validated = false;
  }

  ngOnInit() {
    this.userCardForm = this.formBuilder.group({
      card : [''],
      cardBirthDateDay : [''] ,
      cardBirthDateMonth : [''],
      cardBirthDateYear : [''],
    });

    this.date = new Date();
    this.date.setDate(this.date.getDate() -1);
    
  }


  setCard(value: string){

    switch(value) {
        case 'use':
          this.useCard = true;
          //this.userCardForm.addControl('cardPhone', new FormControl('', Validators.required));
          this.userCardForm.addControl('cardPhone', new FormControl(''));
          this.requestCard = false;
          break;
        case 'request': 
          this.useCard = false;
          this.requestCard = true;
          this.userCardForm.removeControl('cardPhone');
          break;
      };

  }

  sendRequest(){
    this.user.get_plusi_card = 1;
    // Update users card request
    this.users.requestCard(this.user).subscribe();
  }

  validateCard() : any{ 

    if (this.userCardForm.invalid){
      return null;
    }

    this.submitted = true;

    return this.utils.validatePlusiCard(
          this.f.cardPhone.value, 
          this.datePipe.transform( new Date(this.f.cardBirthDateYear.value,this.f.cardBirthDateMonth.value -1 , this.f.cardBirthDateDay.value), 'dd/MM/yyyy')).subscribe( id_plusi_card => {
            this.validated = true;
            this.user.get_plusi_card = 0;
            this.user.phone_plusi_card = this.f.cardPhone.value;
            this.user.birth_plusi_card = this.datePipe.transform( new Date(this.f.cardBirthDateYear.value,this.f.cardBirthDateMonth.value -1 , this.f.cardBirthDateDay.value), 'dd/MM/yyyy');
            this.user.id_plusi_card = id_plusi_card;

            // Updates user card data
            return this.users.update(this.user).subscribe( result => {
              this.validCard = id_plusi_card !== null;
              this.refreshPoints();
            });
        },
        error => {
          this.toastr.error (this.translate.instant('USERCARD.VALIDATION_ERROR')); 
          this.validated = true;
          this.validCard = false;
          this.user.id_plusi_card = '';
        }
      );
  }

  refreshPoints(){
    if (this.user.get_plusi_card == 0){
      this.users.getPromoPoints().subscribe( 
        result => {
          this.plusiPoints = result;
      } , error =>{   
        this.plusiPoints = new PlusiPoints();
      });
    }
  }

  /*
  getCardInfo(){
    if (this.user.get_plusi_card == 0 && this.user.id_plusi_card && this.user.id_plusi_card != ''){
      this.utils.getPlusiCard(this.user.phone_plusi_card, this.user.birth_plusi_card).subscribe(
        card => {
          this.userCard = card;
        },
        error => {
          this.toastr.error();
        }
      )
    }
  }
  */
 
  
}
